import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavService } from '../../../../../services/nav.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NavItem } from '../../../vertical/sidebar/nav-item/nav-item';
import { NavItemVisibilityService } from '../../../../../services/nav-item-visibility.service';
import { AuthenticationService } from '../../../../../services/apps/Authentication/authentication.service';
import { PermissionsService } from '../../../../../services/permissions/permissions.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-horizontal-nav-item',
  imports: [TablerIconsModule, CommonModule, MatIconModule],
  templateUrl: './nav-item.component.html',
})
export class AppHorizontalNavItemComponent implements OnInit, OnDestroy {
  @Input() depth: any;
  @Input() item: NavItem;

  hasPermission = true;
  private destroy$ = new Subject<void>();

  constructor(
    public navService: NavService,
    public router: Router,
    private readonly navItemVisibility: NavItemVisibilityService,
    private readonly authService: AuthenticationService,
    private readonly permissionsService: PermissionsService
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit(): void {
    this.updateVisibility();
    this.authService.currentUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateVisibility());
    this.permissionsService.permissions$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateVisibility());
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.updateVisibility());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateVisibility(): void {
    this.hasPermission = this.navItemVisibility.isVisible(this.item);
  }

  isItemActive(nav: NavItem): boolean {
    if (nav.activeRoutePrefixes?.length) {
      const path = this.router.url.split('?')[0].split('#')[0];
      return nav.activeRoutePrefixes.some((p) => path === p || path.startsWith(p + '/'));
    }
    if (!nav.route) {
      return false;
    }
    const route = nav.route.startsWith('/') ? nav.route : `/${nav.route}`;
    return this.router.isActive(route, true);
  }

  onItemSelected(item: NavItem): void {
    if (!item.children || !item.children.length) {
      if (item.route) {
        const route = item.route.startsWith('/') ? item.route : `/${item.route}`;
        void this.router.navigateByUrl(route);
      }
    }
  }
}
